import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { EmptySetting, IModel, IReqPublishSetting } from "./ReqPublishSetting";
import { IPermissionProps } from "../../models/Login";
import { format } from "date-fns";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps
}
export interface IModel2 {
    open: boolean,
    singleData: IReqPublishSetting
}


export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], count: 0, loading: false } as { tableData: Array<IReqPublishSetting>, count: number, loading: boolean });
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);

    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });

    useEffect(() => {
        loadTableData();
    }, [globalFilter, lazyParams, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData(prev => ({ ...prev, loading: true }));
        const response = await Fetch("ReqPublishSetting", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${globalFilter}`, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data.data, count: data.count, loading: false });
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptySetting });
    };


    const openEdit = (rowDatauser: IReqPublishSetting) => {
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage Req Publish Settings</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );

    const actionBodyTemplate = (rowData: IReqPublishSetting) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
            </div>
        );
    };

    const showYesOrNo = (yes?: boolean) => {
        return yes ? <i className="pi pi-check" style={{ color: 'green' }}></i> :
            <i className="pi pi-times" style={{ color: 'gray' }}></i>;
    }

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }} exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small"
                value={tableData.tableData} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No record found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column field="company_Name" header="Company" sortable />
                <Column field="branchName" header="Branch" sortable />
                <Column field="role_Name" header="Role" sortable />
                <Column field="publishBySkill" header="PublishBySkill" body={(r: IReqPublishSetting) => showYesOrNo(r.publishBySkill)} />
                <Column field="publishInBranch" header="PublishInBranch" body={(r: IReqPublishSetting) => showYesOrNo(r.publishInBranch)} />
                <Column field="publishInCompany" header="PublishInCompany" body={(r: IReqPublishSetting) => showYesOrNo(r.publishInCompany)} />
                <Column field="publishGlobally" header="PublishGlobally" body={(r: IReqPublishSetting) => showYesOrNo(r.publishGlobally)} />
                <Column body={actionBodyTemplate} />
            </DataTable>
        </>
    );
}
